import { inject, observer } from 'mobx-react';
import { fetchSaleStateBtn, handleInstaLink, isBuyNowProducts, scrollToEle } from '@/utils';
import { ProductTracker } from '@/utils/Tracker';
import ThirdPartyPlatformConfig from '@/utils/configs/ThirdPartyPlatform.config';
import CustomSkinHelper from '@/pages/product/components/CustomSkin/helper';
import styles from './index.module.less';
import { reportInPurchase } from '@/pages/search/report';
import { VB_PID, VB_RELATED } from '@/utils/configs/product.config';
import { useEffect } from 'react';

/**
 * 加购按钮，缺货则显示到货提醒
 * @param {string} from stickyBar 底部导航 | page 默认
 * @param {object} btnStyle
 * @param {object} style
 */
const ProductSubmit = inject(
  'area',
  'product',
  'app',
  'abtest'
)(
  observer((props) => {
    const {
      product: {
        addProductsToCart,
        curSelectCommodity,
        productDetail: { id: pid, isNeedHidePrice },
        setStateValue,
        productTotalPrice,
        isSelectPersonalized,
      },
      app: { isMobile },
      area: { LANG },
      abtest: { fixedSendHitMethods },
      from = 'page',
      style = {},
      btnStyle = {},
    } = props;
    const { isOutOfStock, id: cid } = curSelectCommodity;

    const redirectData = ThirdPartyPlatformConfig.getRedirectData({ pid, cid: curSelectCommodity.id });
    const disabled = productTotalPrice.amount <= 0;

    const customSkinState = CustomSkinHelper.handleProductPageSubmit({
      mobxProduct: props.product,
    });

    // 导流产品文案或销售状态文案
    const getButtonText = () => {
      if (isNeedHidePrice) return LANG['common.btn.contact_sales'];
      if (isOutOfStock) return fetchSaleStateBtn(curSelectCommodity, LANG);
      if (redirectData?.text) return redirectData?.text;
      if (customSkinState.isCustomSkinPage) {
        if (!customSkinState.hasCustomSkin) return LANG['common.btn.customize'];
        return LANG['product.sale_state.add_to_cart'];
      }
      return fetchSaleStateBtn(curSelectCommodity, LANG, 'productPageSubmit');
    };

    const handleAddToCart = () => {
      ProductTracker.productPage({
        action: 'add_to_cart',
        productState: props.product,
        data: { from: `${from}${isSelectPersonalized ? '_diy' : ''}` },
      });

      try {
        const isBuyNow = isBuyNowProducts(curSelectCommodity);

        if (!isBuyNow) {
          // 加车上报
          reportInPurchase({
            pid,
            cid,
            type: 'cart',
            detail: '',
            value: `${props?.product?.curSelectCommodityCount || 1}`,
          });
        }
      } catch (err) {
        console.error(err);
      }

      const sendHitMethod = fixedSendHitMethods['add_to_cart'];
      sendHitMethod && sendHitMethod(curSelectCommodity);

      addProductsToCart();
    };

    const handleNotify = () => {
      setStateValue('subscribeCommodityModalVisible', true);
      setStateValue('subscribeCommodity', {
        commodityId: curSelectCommodity.id,
        productId: curSelectCommodity.product,
      });
      ProductTracker.productPage({
        action: 'stock_notice',
        productState: props.product,
      });
    };

    // 联系销售的商品处理
    const handleContactSale = () => {
      // vb滚动到下面表单，vb配件跳转官网页面
      if (pid === VB_PID) {
        scrollToEle('#contactus', isMobile ? 160 : 20, 'instant');
      } else if (VB_RELATED.includes(pid)) {
        window.open(handleInstaLink('www', '/product/insta360-connect#page_contact', ''));
      }
    };

    const onClick = () => {
      // 联系销售的优先级比缺货高
      if (isNeedHidePrice) return handleContactSale();

      // 缺货弹窗优先级比disabled高
      if (isOutOfStock) return handleNotify();
      if (disabled) return;

      // 如果是定制产品页，且不存在定制贴则唤起定制弹窗
      const isCustomSkin = CustomSkinHelper.isCustomSkin({ commodityId: curSelectCommodity.id });
      if (!customSkinState.hasCustomSkin && isCustomSkin) return window?.CustomSkin?.handleEdit();

      return handleAddToCart();
    };

    useEffect(() => {
      // related-accessories abt
      props.product.getX3X4Accessories();
    }, []);

    return (
      <div className={styles.Submit} style={style}>
        <button
          id='product_submit_btn'
          className={`${styles.btnBuy} ${!isOutOfStock && disabled ? styles.disable : ''} ${
            isOutOfStock ? styles.notify : ''
          }`}
          data-from={from}
          style={btnStyle}
          onClick={onClick}
        >
          {getButtonText()}
        </button>
      </div>
    );
  })
);

export default ProductSubmit;
